import React from "react";

export default function HowToApplyHead() {
  return (
    <>
      <div className="container text-center">
        <div className="row pt-2 pb-4">
          <div className="col-md-12">
            <h2>How to Apply</h2>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <p>
              Interested in taking your career to the next level with Bright
              Airways? Explore our current job openings and apply today. We’re
              always looking for dedicated, passionate individuals to join our
              growing team. If you have a passion for aviation and are ready to
              be part of a dynamic, forward-thinking company, we want to hear
              from you
              <br />
              <b>Step 1:</b> Browse our available job openings <br />
              <b>Step 2:</b> Submit your resume and complete the online
              application <br />
              <b>Step 3:</b> Prepare for an exciting new journey with Bright
              Airways!
            </p>
          </div>
        </div>
        <div className="row mt-3 mb-3">
          <div className="col-md-12">
            <h3>Join Bright Airways Today</h3>
            <p>
              If you're ready to start an exciting career with Bright Airways,
              don’t wait. Whether you're fresh out of school or looking to take
              your skills to the next level, we offer opportunities for
              individuals of all experience levels. Join us in our mission to
              provide top-tier service and elevate the travel experience for
              passengers worldwide.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
